import { customAlphabet } from "nanoid";

/**
 * Canvas op のクライアント ID を生成する。
 * dispatcher と競合再送で同じ文字種・長さを使い、既存 op との互換性を維持する。
 */
export const generateCanvasOpId = customAlphabet(
  "23456789abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ",
  16
);
